import * as React from "react";
import { forwardRef } from "react";
const SvgCheckInput = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.55,20.23a1.27,1.27,0,0,1-.9-.38L2.39,14.31a1.22,1.22,0,0,1,0-1.74,1.24,1.24,0,0,1,1.75,0l4.3,4.53L19.87,3.45a1.23,1.23,0,0,1,1.74-.16A1.24,1.24,0,0,1,21.77,5L9.5,19.79a1.24,1.24,0,0,1-.91.44Z" }));
const ForwardRef = forwardRef(SvgCheckInput);
export default ForwardRef;
